import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-privacy',
  imports: [CommonModule],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss',
})
export class PrivacyComponent implements OnInit {
  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.setMetaData();
  }

  private setMetaData(): void {
    const title = `Privacy Policy | Only Used Tesla`;
    const description = `Privacy Policy | Only Used Tesla | A Place Exclusively Dedicated To Buying And Selling Used Teslas. Learn how we protect your data and respect your privacy.`;
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/our-perfect-privacy-mission';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }
}
